import React from 'react';
import { Company } from '../../models/CompanyModel';
import BaseInput from '../Base/BaseInput';
import {
  finalizeFormTextField,
  sanitizeFormTextField,
} from '../../utils/textInputSanitize';

type Props = {
  value: Company;
  onChange: (c: Company) => void;
  error?: string | null;
  fieldErrors?: Record<string, string>;
};

const CompaniesForm: React.FC<Props> = ({ value, onChange, fieldErrors = {} }) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value: v } = e.target;
    onChange({ ...value, [name]: sanitizeFormTextField(name, v) });
  };

  const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    const { name, value: v } = e.target;
    const next = finalizeFormTextField(name, v);
    if (next !== (value as any)[name]) {
      onChange({ ...value, [name]: next });
    }
  };

  return (
    <div className="company-form">
      <BaseInput
        label="Nombre de la empresa"
        name="name"
        value={value.name ?? ''}
        onChange={handleChange}
        onBlur={handleBlur}
        required
        autoFocus
        maxLength={120}
        error={fieldErrors.name}
      />
    </div>
  );
};

export default CompaniesForm;
